module.exports = __webpack_public_path__ + "img/金星.a5705977.svg";